<template>
	<div>
		<el-dialog :title="langtrans().jlhgzz[languageIndex]" :visible.sync="dialogFormVisible" center>
			<el-form :model="cooperationData">
				<el-form-item :label="langtrans().gsmccc[languageIndex]" class="input">
					<el-input v-model="cooperationData.name" autocomplete="off" :placeholder="langtrans().srgsmc[languageIndex]"></el-input>
				</el-form-item>
				<el-form-item :label="langtrans().gswzhj[languageIndex]" class="textarea">
					<!-- <el-input v-model="form.url" autocomplete="off"></el-input> -->
					<el-input type="textarea" :rows="3" :placeholder="langtrans().srgswz[languageIndex]" v-model="cooperationData.des">
					</el-input>
				</el-form-item>
				<el-form-item :label="langtrans().lxjrxm[languageIndex]" class="input">
					<el-input v-model="cooperationData.contactName" autocomplete="off" :placeholder="langtrans().srgslx[languageIndex]"></el-input>
				</el-form-item>
				<el-form-item :label="langtrans().lxjfs[languageIndex]" class="input">
					<el-input v-model="cooperationData.contact" autocomplete="off" :placeholder="langtrans().srlxjr[languageIndex]"></el-input>
				</el-form-item>
				<el-form-item :label="langtrans().hgzzzy[languageIndex]" class="input">
					<el-input v-model="cooperationData.cooperation" autocomplete="off" :placeholder="langtrans().srnddd[languageIndex]"></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button class="p_btn" type="primary" @click="submitFun()">{{langtrans().tdsjxs[languageIndex]}}</el-button>
			</div>
		</el-dialog>
		<el-dialog :title="langtrans().tdsjcg[languageIndex]" :visible.sync="successdialog" center>
			<p class="p_node">
				<img class="img_node" src="./images/success_icon.png" alt="">
			</p>
		</el-dialog>		
	</div>
</template>

<script>
	import langtrans from "@/assets/languagejs/jlhz.vue.trans.js";
	import { postCooperation } from '@/views/axios/api.js';
	export default{
		data(){
			return{
				successdialog:false,
				dialogFormVisible:false,
				cooperationData: {
					name: '',
					des: '',
					contactName: '',
					contact: '',
					cooperation: '',
					type:1
				}				
			} 
		},
		computed:{
			languageIndex(){
				return this.$store.state.language
			}
		},	
		methods: {
			langtrans(){
				return langtrans
			},
			setpopShow(status,id){
				this.dialogFormVisible=status;
				this.cooperationData.type=id
			},
			submitFun() {
				if(this.cooperationData.name == ''){
					return this.$message.error('请输入公司名称');
				}
				if(this.cooperationData.contactName == ''){
					return this.$message.error('请输入联系人姓名');
				}
				if(this.cooperationData.contact == ''){
					return this.$message.error('请输入联系人方式');
				}
				postCooperation(this.cooperationData)
					.then(res => {
						console.log(res)
						if(res.data.code == 0){
							this.setpopShow(false)
						}
						
					})
					.catch(err => {
						console.log(err)
					})
			},			
		}
	}
</script>

<style scoped="scoped">
	@import url(./css/programme.css);
</style>



// WEBPACK FOOTER //
// src/components/programme/jlhz.vue